/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.CancelReregistrationController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { CancelReregistrationRequest } from '../models/cancel-reregistration-request';
import { CancelReregistrationResponse } from '../models/cancel-reregistration-response';

@Injectable()
export class CancelReregistrationApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }


    public cancelReregistration(request: CancelReregistrationRequest, spinnerMessage: string = null): Observable<CancelReregistrationResponse> {
        return this.httpClient.post<CancelReregistrationResponse>(`/api/cancelreregistration`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
